import React from 'react'
import { Link } from 'react-router-dom'
import { TournamentProps } from '../../_common/model/tournament'

export const BracketButton = (props: TournamentProps) => {
    return (
        <Link to={`/tournament/brackets/${props.id}`} className="btn-ac ic-brackets" state={props} ><span>Brackets</span></Link>
    )
}